export default "__VITE_ASSET__Bi4dZVAT__"